import './loader.scss';

const loaderElement = document.createElement('div');
loaderElement.innerHTML = require('./loader.html').template;

const WAIT_CLASS = 'wait';

export default class LoaderService {
    /**
     * @param element        DOMNode  If an element node is given, the loader is shown contextually. You need to set the
     *                                `position:relative` to the element manually in your style.
     *
     * @param customClasses  Array    Custom classes to be added if needed. ie loader--small, loader--whatever, i-like-this-class...
     */
    constructor(element = document.body, customClasses = []) {

        // prevent element = null when null is explicitly passed as first param
        this.element = element !== null ? element : document.body;
        this.customClasses = customClasses;
        this.visible = false;
    }

    show(blockScrolling = false) {
        this.visible = true;

        if (blockScrolling || this.element === document.body) {
            document.body.style.overflow = 'hidden';
        }

        if (this.loader) {
            this.loader.style.display = 'block';
            return this;
        }

        // create a local deep copy to do not interfere with the original reference
        const localLoader = Object.assign(loaderElement);

        // append modifiers if passed
        if (this.customClasses.length > 0) {
            localLoader.firstChild.classList.add(...this.customClasses);
        }

        this.loader = this.element.appendChild(localLoader);

        return this;
    }

    hide() {
        document.body.style.overflow = 'auto';
        this.loader.style.display = 'none';
        this.visible = false;
        return this;
    }

    isLoading() {
        return this.visible;
    }

    remove() {
        document.body.style.overflow = 'auto';

        if (this.loader) {
            this.loader.remove();
            this.visible = false;
            delete this.loader;
        }
        return this;
    }

    /**
     * Remove all the loaders instances found in the page.
     */
    static removeAll() {
        document.body.style.overflow = 'auto';
        document.querySelectorAll('.loader--v2').forEach((el) => {
            el.parentNode.remove();
        });
    }


    static cursorWait(shouldDisplayWait = true) {
        shouldDisplayWait ? document.body.classList.add(WAIT_CLASS) : document.body.classList.remove(WAIT_CLASS);
    }


}


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/loader/v2/loader.service.js